module.exports = __webpack_public_path__ + "static/img/comment.f5a54412.svg";